import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Card, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const summary = {
  activeHosts: 247,
  activeHostsChange: 12,
  revenue: 142580,
  revenueChange: 8,
  suspendedHosts: 12,
  suspendedChange: -3,
};

const hostData = [
  { name: 'Emma Thompson', subscription: 'Premium', revenue: 12450, botels: 8, status: 'Active' },
  { name: 'Emma Thompson', subscription: 'Basic', revenue: 5870, botels: 3, status: 'Suspended' },
  { name: 'Emma Wilson', subscription: 'Premium', revenue: 12450, botels: 8, status: 'Active' },
];

const statusColor = (status: string) => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'Suspended':
      return 'error';
    default:
      return 'default';
  }
};

const HostPartnerManagement = () => (
  <Box sx={{ position: 'relative' }}>
    <Typography variant="h6" sx={{ color: '#fff', mb: 2, fontWeight: 700 }}>
      Host & Partner Management
    </Typography>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid size={{xs: 12, md: 4}}>
        <Card sx={{ p: 2, background: '#181F2A', color: '#fff', boxShadow: 3 }}>
          <Typography variant="subtitle2">Total Active Hosts</Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>{summary.activeHosts}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <ArrowUpwardIcon fontSize="small" sx={{ color: '#4CAF50', mr: 0.5 }} />
            <Typography variant="body2" sx={{ color: '#4CAF50' }}>+{summary.activeHostsChange} This Week</Typography>
          </Box>
        </Card>
      </Grid>
     <Grid size={{xs: 12, md: 4}}>
        <Card sx={{ p: 2, background: '#181F2A', color: '#fff', boxShadow: 3 }}>
          <Typography variant="subtitle2">Total Revenue</Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>${summary.revenue.toLocaleString()}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <ArrowUpwardIcon fontSize="small" sx={{ color: '#4CAF50', mr: 0.5 }} />
            <Typography variant="body2" sx={{ color: '#4CAF50' }}>8% From Last Month</Typography>
          </Box>
        </Card>
      </Grid>
      <Grid size={{xs: 12, md: 4}}>
        <Card sx={{ p: 2, background: '#181F2A', color: '#fff', boxShadow: 3 }}>
          <Typography variant="subtitle2">Suspended Hosts</Typography>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>{summary.suspendedHosts}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <ArrowDownwardIcon fontSize="small" sx={{ color: '#F44336', mr: 0.5 }} />
            <Typography variant="body2" sx={{ color: '#F44336' }}>3% From Last Month</Typography>
          </Box>
        </Card>
      </Grid>
    </Grid>
    <Card sx={{ p: 2, background: '#181F2A', boxShadow: 3 }}>
      <TableContainer component={Paper} sx={{ background: 'transparent' }}>
        <Table>
          <TableHead>
            <TableRow sx={{ background: '#232B3E' }}>
              <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Host Name</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Subscription</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Revenue</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Botels</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Status</TableCell>
              <TableCell sx={{ color: '#fff', fontWeight: 700 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {hostData.map((host, idx) => (
              <TableRow key={idx} sx={{ background: idx % 2 ? '#1C2533' : 'transparent' }}>
                <TableCell sx={{ color: '#fff' }}>{host.name}</TableCell>
                <TableCell sx={{ color: '#fff' }}>{host.subscription}</TableCell>
                <TableCell sx={{ color: '#fff' }}>${host.revenue.toLocaleString()}</TableCell>
                <TableCell sx={{ color: '#fff' }}>{host.botels}</TableCell>
                <TableCell>
                  <Chip
                    label={host.status}
                    color={statusColor(host.status)}
                    size="small"
                    sx={{ fontWeight: 700 }}
                  />
                </TableCell>
                <TableCell>
                  <IconButton color="primary">
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
        backdropFilter: 'blur(2px)',
        pointerEvents: 'none',
      }}
    >
      <Typography
        sx={{
          color: '#9ca3af',
          fontSize: 24,
          fontWeight: 'bold',
          mb: 1,
        }}
      >
        Coming Soon
      </Typography>
      <Typography
        sx={{
          color: '#6b7280',
          fontSize: 16,
          textAlign: 'center',
          px: 2,
        }}
      >
        This feature will be available in a future release
      </Typography>
    </Box>
  </Box>
);

export default HostPartnerManagement; 